import { render, staticRenderFns } from "./Up65Page.vue?vue&type=template&id=1d3e16e5&scoped=true&"
import script from "./Up65Page.vue?vue&type=script&lang=ts&"
export * from "./Up65Page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3e16e5",
  null
  
)

export default component.exports